import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button/Button";
import api from "../../js/api";
import './Buses.scss';
import Menu from "../../components/Menu/Menu";

export default function Bus() {
    const { busStopID } = useParams();
    const navigate = useNavigate();
    const [stop, setStop] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStop = async () => {
        const res = await api.get(`/bus/stops/${busStopID}`, { silent: true });
        console.log('Bus stop data:', res);
        if (res?.error) {
            setError('Parada no encontrada.');
            setLoading(false);
            return;
        }
        setStop(res);
        setLoading(false);
    };

    useEffect(() => {
        fetchStop();
        const interval = setInterval(fetchStop, 30000);
        return () => clearInterval(interval);
    }, [busStopID]);

    const updatedAt = stop ? new Date(stop.updated_at).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : null;

    return (
        <div id="bus">
            <div className='centered-container'>
                {loading && <p className="bus-status">Cargando...</p>}
                {error && <p className="bus-status">{error}</p>}

                {stop && (
                    <>
                        <h2>{stop.name}</h2>
                        <p className="updated-at">Actualizado a las {updatedAt}</p>

                        {!stop.arrivals?.length ? (
                            <p className="bus-status">No hay próximos buses.</p>
                        ) : (
                            <div className="arrivals">
                                {stop.arrivals.map((a, i) => (
                                    <div key={i} className="arrival">
                                        <span className="route">{a.route}</span>
                                        <span className="destination">{a.destination}</span>
                                        <span className="minutes">{a.minutes} min</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>

        </div>
    );
}
